// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"260":"publishers","687":"agenda","797":"event","962":"home"}[chunkId] + "." + {"260":"3a957b45","687":"7b7089d4","797":"6e2068f2","962":"3e07928a"}[chunkId] + ".js";
};